import { Typography } from "@mui/material";
import GenericMessageUI from "./emptyStateUIContainers/GenericMessageUI";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function Unauthorized() {
  return (
    <GenericMessageUI
      title={<Typography variant="h6">Permission Denied</Typography>}
      message={
        <Typography variant="body1">
          You do not have permission to access this space.
        </Typography>
      }
      icon={<LockOutlinedIcon />}
    ></GenericMessageUI>
  );
}
